// import axios from 'axios'
import encodeObjForm from './encodeObjForm.json'
function encodeQuery(params) {
    Object.keys(params).forEach((key) => {
        try {
            if(key != "offer" && key != "state" && key != "orig_bbdd")
                params[key] = (encodeObjForm[key])[params[key]]
        } catch {
            ()=>{}
        }
    })
    if(params.comercial){
        params.comercial = params.comercial.id
    }
    if(params.offer){
        let offer = JSON.parse(JSON.stringify(params.offer))
        params.offer = []
        Object.keys(encodeObjForm.offer).forEach((key) => {
            // Si hay una oferta con esa clave en la lista le asigamos su valor de num en la peticion
            // Si no, lo ha eliminado y le asignamos un 0
            let element = offer.find( el => el.name==key )
            if(element){
                params.offer.push(encodeObjForm.offer[key] + ':' + (element.num == 1 ? 't' : 'f'))
            }
        })
    }
    if(params.state){
        let state = JSON.parse(JSON.stringify(params.state))
        params.state = []
        Object.keys(encodeObjForm.state).forEach((key) => {
            // Si hay un estado con esa clave en la lista le asigamos su valor de num en la peticion
            // Si no, lo ha eliminado y le asignamos un 0
            if(state.some( el => el==key )){
                params.state.push(encodeObjForm.state[key])
            }
        })
    }
    if(params.orig_bbdd){
        let state = JSON.parse(JSON.stringify(params.orig_bbdd))
        params.orig_bbdd = []
        Object.keys(encodeObjForm.orig_bbdd).forEach((key) => {
            // Si hay un estado con esa clave en la lista le asigamos su valor de num en la peticion
            // Si no, lo ha eliminado y le asignamos un 0
            if(state.some( el => el==key )){
                params.orig_bbdd.push(encodeObjForm.orig_bbdd[key])
            }
        })
    }
}

export {encodeQuery}
